// Заглушка для веб-версии, в реальном приложении здесь был AsyncStorage
const NOTIFIED_KEY = "@notified_orders";

export async function getNotifiedOrderNumbers() {
    try {
        const raw = localStorage.getItem(NOTIFIED_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

export async function clearNotifiedOrderNumbers() {
    localStorage.removeItem(NOTIFIED_KEY);
}
